// extracted by mini-css-extract-plugin
module.exports = {"cc-switcher":"usbXl","cc-switcher-size-large":"_2CRZr","cc-switcher-btn":"_1aG32","cc-switcher-on":"r7x-u","cc-switcher-off":"_1MS-k"};